import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ConfigService } from '@igo2/core/config';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { ZzzConfigService } from '../../zzz/core/config/config.service';
import { Media, MediaService } from '@igo2/core/media';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [
        CommonModule,
        MatToolbarModule,
        TranslateModule,
        RouterModule
    ]
})
export class HeaderComponent implements OnInit {
  headerLogo: string;
  headerLogoPrint: string;
  isCarteLegere$ = new BehaviorSubject<boolean>(false);

  constructor(
    private configService: ConfigService,
    private zzzConfigService: ZzzConfigService,
    private mediaService: MediaService
  ) {
    this.computeHeader();
  }

  ngOnInit() {
    this.isCarteLegere$.next(
      !this.zzzConfigService.get().estIntranet
      && !this.zzzConfigService.get().estPartenaire
    );
  }

  computeHeader() {
    this.headerLogo = this.configService.getConfig('header.logo');
    this.headerLogoPrint = this.configService.getConfig('header.logoPrint');
  }

  isMobile(): boolean {
    return this.mediaService.getMedia() === Media.Mobile;
  }
}
